import axios from 'axios'
import config from '../config/app'

const cartAPI = {
  getCart () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/cart').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateCart (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/cart', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  setContributionGroupID (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/cart/contribution', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  removeContributionGroupID (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/cart/contribution/remove', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCartByGroup ($groupId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/cart/group/' + $groupId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  sendEcardPreview (currentTemplateId, ShortMsg) {
    let url = config.server + '/cart/preview-ecard'
    let headers = new Headers()
    let token = localStorage.getItem('token')
    let authToken = token.indexOf('Bearer') > -1 ? token : 'Bearer ' + token
    headers.append('Authorization', authToken)
    let params = '?current_template_id=' + currentTemplateId + '&msg=' + ShortMsg
    return fetch(url + params, {headers}).then(response => response.blob())
  },
  downloadCertificate (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/cart/download-certificate', data, {
        responseType: 'blob'
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default cartAPI



// WEBPACK FOOTER //
// ./src/api/cart.js